// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSavingsPath = 'm2.229 5.372.646 1.378.646-1.378c.176-.374.477-.676.851-.851l1.378-.646-1.378-.647a1.766 1.766 0 0 1-.851-.85L2.875 1l-.646 1.378a1.766 1.766 0 0 1-.851.85L0 3.875l1.378.646c.374.175.675.477.851.851ZM7.213 5l-2.074 6h-2.34L.05 19H19.95l-2.753-8h-2.336l-2.075-6H7.213Zm1.424 2h2.726l1.382 4H7.254l1.383-4Zm4.434 6H15.773l1.375 4h-5.453l1.376-4Zm-2.114 0-.958 2.783L9.042 13h1.915Zm-6.73 0h2.701l1.375 4H2.853l1.376-4Zm13.148-5.625-.59-1.258a1.612 1.612 0 0 0-.777-.777l-1.258-.59 1.258-.59c.342-.16.617-.436.777-.777l.59-1.258.59 1.258c.16.341.435.617.777.777L20 4.75l-1.258.59c-.342.16-.617.435-.777.777l-.59 1.258Z';
var IconSavings = baseIcon('IconSavings', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSavingsPath
});
export default IconSavings;
//# sourceMappingURL=index.js.map